import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { findIndex } from 'lodash'

import { AppThunk } from '../store'
import {
  getMemberWeeklyTrackTime,
  patchMemberWeeklyTrackTime,
  deleteMemberWeeklyTrackTime,
  postMemberWeeklyTrackTime,
} from '../../apis/setting'
import { setErrors } from '../common/errorsSlice'
import {
  deleteMemberWeeklyTrackTimeRequest,
  memberWeeklyTrackTime,
  patchMemberWeeklyTrackTimeRequest,
  postMemberWeeklyTrackTimeRequest,
} from '../../types/setting'

interface memberWeeklyTrackTimeState {
  member_list: memberWeeklyTrackTime[]
  uncreate_member_list: memberWeeklyTrackTime[]
  isLoading: boolean
}

const initialState: memberWeeklyTrackTimeState = {
  member_list: [],
  uncreate_member_list: [],
  isLoading: true,
}

const memberWeeklyTrackTimeSlice = createSlice({
  name: 'member_weekly_track_time',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getMemberWeeklyTrackTimeSuccess: (state, action: PayloadAction<memberWeeklyTrackTimeState>) => {
      state.member_list = action.payload.member_list
      state.uncreate_member_list = action.payload.uncreate_member_list
      state.isLoading = false
      return state
    },
    updateMembersWeeklyTrackTimeSuccess: (state, action: PayloadAction<patchMemberWeeklyTrackTimeRequest>) => {
      action.payload.member_ids.forEach((id) => {
        const index = findIndex(state.member_list, { id: id })
        if (action.payload.change_authority != null) {
          state.member_list[index].change_authority = action.payload.change_authority
        }
        if (action.payload.weekly_track_times != null) {
          state.member_list[index].weekly_track_times = action.payload.weekly_track_times
        }
      })
      state.isLoading = false
      return state
    },
    destroyMembersWeeklyTrackTimeSuccess: (state, action: PayloadAction<deleteMemberWeeklyTrackTimeRequest>) => {
      const newList = state.member_list.filter((v) => !action.payload.member_ids.includes(v.id))
      // eslint-disable-next-line max-len
      const tmpUnCreateMemberList = [...state.uncreate_member_list, ...state.member_list.filter((v) => action.payload.member_ids.includes(v.id))].sort((a, b) => a.id - b.id)
      state.member_list = newList
      state.uncreate_member_list = tmpUnCreateMemberList
      state.isLoading = false
      return state
    },
    createMembersWeeklyTrackTimeSuccess: (state, action: PayloadAction<postMemberWeeklyTrackTimeRequest>) => {
      const addMemberList = state.uncreate_member_list.filter((v) => action.payload.member_ids.includes(v.id)).map((v) => (
        {
          ...v,
          change_authority: action.payload.change_authority,
          weekly_track_times: action.payload.weekly_track_times,
        }
      ))
      state.member_list.push(...addMemberList)
      state.uncreate_member_list = state.uncreate_member_list.filter((v) => !action.payload.member_ids.includes(v.id))
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getMemberWeeklyTrackTimeSuccess,
  updateMembersWeeklyTrackTimeSuccess,
  destroyMembersWeeklyTrackTimeSuccess,
  createMembersWeeklyTrackTimeSuccess,
  requestFailure,
} = memberWeeklyTrackTimeSlice.actions

export const memberWeeklyTrackTimeReducer = memberWeeklyTrackTimeSlice.reducer

export const fetchMemberWeeklyTrackTime = (
  params: {only_oneself: boolean},
  callback?: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getMemberWeeklyTrackTime(params)
    .then((result) => {
      dispatch(getMemberWeeklyTrackTimeSuccess(result))
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const updateMembersWeeklyTrackTime = (
  params: patchMemberWeeklyTrackTimeRequest,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  patchMemberWeeklyTrackTime(params)
    .then(() => {
      dispatch(updateMembersWeeklyTrackTimeSuccess(params))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const destroyMembersWeeklyTrackTime = (
  params: deleteMemberWeeklyTrackTimeRequest,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  deleteMemberWeeklyTrackTime(params)
    .then(() => {
      dispatch(destroyMembersWeeklyTrackTimeSuccess(params))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createMembersWeeklyTrackTime = (
  params: postMemberWeeklyTrackTimeRequest,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postMemberWeeklyTrackTime(params)
    .then(() => {
      dispatch(createMembersWeeklyTrackTimeSuccess(params))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
